import { Announcement } from '@breathelife/types';

import { LeadPlatformStore } from '../../types';

export const getAnnouncements = (state: LeadPlatformStore): Announcement[] => {
  return state.leadPlatform.announcements.announcements;
};

export const getSelectedAnnouncement = (state: LeadPlatformStore): Announcement | undefined => {
  return state.leadPlatform.announcements.selectedAnnouncement;
};

export const getAnnouncementsIsFetching = (state: LeadPlatformStore): boolean => {
  return state.leadPlatform.announcements.isFetching;
};

export const getAnnouncementsIsCreating = (state: LeadPlatformStore): boolean => {
  return state.leadPlatform.announcements.isCreating;
};

export const getAnnouncementsIsUpdating = (state: LeadPlatformStore): boolean => {
  return state.leadPlatform.announcements.isUpdating;
};

export const getAnnouncementsIsDeleting = (state: LeadPlatformStore): boolean => {
  return state.leadPlatform.announcements.isDeleting;
};

export const getAnnouncementsIsReordering = (state: LeadPlatformStore): boolean => {
  return state.leadPlatform.announcements.isReordering;
};

export const getAnnouncementsIsLoading = (state: LeadPlatformStore): boolean => {
  const { isFetching, isCreating, isUpdating, isDeleting, isReordering } = state.leadPlatform.announcements;
  return isFetching || isCreating || isUpdating || isDeleting || isReordering;
};
